var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknownCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 26,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 40,
    height: 1,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12C4.33579 12 4 12.3358 4 12.75C4 13.1642 4.33579 13.5 4.75 13.5H17.9318C18.346 13.5 18.6818 13.1642 18.6818 12.75C18.6818 12.3358 18.346 12 17.9318 12H4.75Z",
    fill: "#24A691"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7955 12C29.3812 12 29.0455 12.3358 29.0455 12.75C29.0455 13.1642 29.3812 13.5 29.7955 13.5H33.75C34.1642 13.5 34.5 13.1642 34.5 12.75C34.5 12.3358 34.1642 12 33.75 12H29.7955Z",
    fill: "#24A691"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 17C4.33579 17 4 17.3358 4 17.75C4 18.1642 4.33579 18.5 4.75 18.5H10.0227C10.4369 18.5 10.7727 18.1642 10.7727 17.75C10.7727 17.3358 10.4369 17 10.0227 17H4.75Z",
    fill: "#24A691"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownCardIcon);
export default __webpack_public_path__ + "static/media/UnknownCardIcon.88e87d101f3e81cfbbfd1cb71df52dfa.svg";
export { ForwardRef as ReactComponent };